import React, {useEffect} from 'react';
import {useHeaderState} from "./headerContext";
import {useDeepCompareEffectNoCheck} from "use-deep-compare-effect";

export const Header = ({
    mobileOpenHandler = () => null,
    className,
    logoutHandler = () => null,
    loginHandler = () => null,
    preselectMuseumId = null,
    appId,
    mobileOpen = false,
    loggedIn,
    onRender = () => null,
    version,
    theme={},
    showMuseums=true,
    search=null,
    actions=[],
    apps=null,
    museums=null,
    user=null,
   buildDate=null,
   alwaysShowHamburger=false
}) => {
    const {ready} = useHeaderState();
    const containerId = 'header--container';

    useDeepCompareEffectNoCheck(() => {
        if (ready) {
            window['renderHeader']({
                mobileOpenHandler: mobileOpenHandler,
                className: className,
                logoutHandler: logoutHandler,
                loginHandler: loginHandler,
                preselectMuseumId: preselectMuseumId,
                appId: appId,
                mobileOpen: mobileOpen,
                loggedIn: loggedIn,
                containerId: containerId,
                themeOptions: theme,
                onRender: onRender,
                version: version,
                showMuseums: showMuseums,
                actions: actions,
                search: search,
                user: user,
                museums: museums,
                apps: apps,
                buildDate: buildDate,
                alwaysShowHamburger: alwaysShowHamburger
            })

        }
    }, [
        loggedIn,
        ready,
        containerId,
        actions,
        user,
        museums,
        apps,
        mobileOpen,
        buildDate,
        alwaysShowHamburger
    ])

    useEffect(() => {
        if(ready) {
            return () => window['unmountHeader'](containerId);
        }
    }, [ready, containerId])

    return <div id={containerId}/>
}